import { ReactComponent as ArrowDownSvg } from '../../assets/icons/arrow-down.svg';

export const ArrowDownIcon: SvgIcon = (props) => {
    return <ArrowDownSvg {...props} />;
};
